import React from 'react'
import Layout from '../Layout/Layout'

const Thematic_Areas = () => {
  return (
    <Layout>
          <div className='uk-container'>
             <h1 className='light uk-text-bold uk-margin-xlarge-top'>Thematic Areas</h1>


             <div className='uk-grid '>
                  <div className='uk-width-3-4@s'>
                   <h2 className='light  uk-text-bold  uk-margin-large-top'>Climate Change</h2>
                   <p className='light'>Climate change is causing global disruption, with vulnerable communities and ecosystems most affected.
                    supports the development and scaling of sustainable ventures through tailored business creation and acceleration programmes.
                    </p>
                    <p className='light'>
                    collaborates with partner organisations to foster entrepreneurship activities that support local climate goals;
                    provides educational and upskilling programmes to equip public and private leadership with innovation capacities essential for tackling climate change
                    helps test and implement new ideas by supporting innovation projects that drive decarbonisation and strengthen climate resilience.</p>

                </div>

                <div className='uk-width-1-4@s'>
                   <p></p>
                </div>

             </div>



               <div className='uk-grid  uk-margin-large-top '>
                  <div className='uk-width-3-4@s'>
                   <h2 className='light  uk-text-bold '>Future of Food.</h2>
                   <p className='light'>Agrifood systems are a leading cause of some of the biggest global challenges,
                     from climate change, resource depletion and waste, to malnutrition, disease and obesity.
                      Innovative solutions are needed at all stages of the food supply chain.
                    </p>
                    <p className='light'>
                        Moolu Venture Lab is creating a Knowledge and Innovation Community dedicated to 
                        making our food system more sustainable. And that can only happen through an
                         inclusive approach where both grower, agrregators and consumer can actively 
                         participate in making a better world.
                    </p>

                        <p className='light'>
                       Moolu Venture Lab supports and accelerates projects, organisations and
                        individuals that share our goals for a healthy and sustainable food system.
                    </p>

                   <div>
                     <h5 className='  uk-text-bold light ' >How Moolu Venture Lab can partner </h5>

                     <p className='light'>Take your ideas from concept to market so you can launch innovative products, 
                        ingredients, and solutions</p>

                     <p className='light'>Engage in a dialogue with the food industry and co-create the future food
                         system through access to our innovative events, digital platforms, and public
                          engagement activities.Benefit from expert mentoring, tailor-made entrepreneurship
                           programmes, and easy-to-access funding to enable you to launch, accelerate, and
                            scale your agrifood business
                            </p>

                

                   </div>


                </div>

                <div className='uk-width-1-4@s'>
                   <p></p>
                </div>

             </div>




             
               <div className='uk-grid  uk-margin-large-top'>
                  <div className='uk-width-3-4@s'>
                   <h2 className='light  uk-text-bold '>Sustainable Energy</h2>
                   <p className='light'>At the centre of Africa’s decarbonisation efforts is the
                     challenge of how to power society. Transport, housing, and industry all require 
                     sustainable energy sources. Renewable energy now offers a cheaper, more
                      efficient and life-changing alternative.
                    </p>

                    <h5 className='light  uk-text-bold '>Moolu Venture Lab can help you through:</h5>
                    <p className='light'>
                       Entrepreneurial education – Develop a skills-building programme in clean energy and energy system design, 
                       while developing the skills and business knowledge needed to test innovative solutions.
                       Innovation-driven research – test and refine breakthrough clean energy ideas and commercialise research results.
                    </p>

                        <p className='light'>
                      Business creation and acceleration – secure resources to establish new companies and build long-term networks 
                      across the clean energy sector. Connect with experts and investors who offer mentoring, support and investment.
                    </p>

                </div>

                <div className='uk-width-1-4@s'>
                   <p></p>
                </div>

             </div>






               <div className='uk-grid uk-margin-large-top'>
                  <div className='uk-width-3-4@s'>
                   <h2 className='light  uk-text-bold '>Digitalization/ Emerging Technology</h2>
                   <p className='light'>The digital transition can be a force for good – if it is in the right hands. Strategically 
                    vital technologies such as AI, machine learning and encryption must be used to benefit both people and planet.
                    </p>

                    <h5 className='light  uk-text-bold '>Moolu Venture Lab can help you through:</h5>
                    <p className='light'>
                       <span className='uk-text-bold'>Entrepreneurial education </span>– access blended, incubation and accelerators entrepreneurial programe
                    </p>

                         <p className='light'>
                       <span className='uk-text-bold'>Innovation </span>–identify and advance breakthrough digital technologies through 
                       cutting-edge Research & Innovation activities.   
                             </p>

                               <p className='light'>
                       <span className='uk-text-bold'>Business creation  </span>–– scale deep-tech ventures through its Open Innovation Factory,
                        which provides funding, mentoring, and access to markets.
                             </p>

                </div>

                <div className='uk-width-1-4@s'>
                   <p></p>
                </div>

             </div>




                 
               <div className='uk-grid uk-margin-large-top'>
                  <div className='uk-width-3-4@s'>
                   <h2 className='light  uk-text-bold '>Creative Sectors & Industries </h2>
                   <p className='light'>Tech alone will not be enough to make “sustainability” tangible for
                     the average Afrcan. It has to be something you can walk through, look at, listen to, 
                     and participate in. Something you can wear or live inside of. This requires the power
                      of art and creativity.
                    </p>


                     <p className='light'>Moolu Culture & Creativity is a Knowledge and Innovation Community
                         that’s bringing creatives from all walks of life together to rethink how we live as
                          Africans. That includes rethinking the way we currently run our cultural and creative
                           sectors and industries from fashion to film and empowering creatives to transform it
                            according to their vision of the green and digital transitions
                    </p>

                    <p className='light'>
                    Imagination has no limits and you won’t either with Culture & Creativity
                   Moolu’s  Culture & Creativity has no lesser ambition than to bring about new
                    wave of cultural and artistic renewal in Europe to accompany the Green and Digital 
                    transitions. It is ready to support artists of all kinds to make this happen. If your 
                    project could contribute to its overarching goals, don’t hesitate to to ask for support!

                    </p>



                    <h5 className='light  uk-text-bold '>Moolu’s Culture & Creativity can help you</h5>
                    <p className='light'>Learn all about how to be more tech-savvy and multidisciplinary 
                        as a creative along with how you can contribute to a more sustainable society</p>

                        <p className='light'>Develop business acumen and innovation skills in experimental
                             spaces, giving you the confidence to launch your creative projects</p>

                             <p className='light'>Find investors and businesses willing to advise you and
                                 support your endeavours</p>


                         <p className='light'>Get the support you need to get your new company off the ground in Europe</p>
                         
                         <p className='light'>Develop a network in the culture and creativity sector that will last a lifetime</p>

                </div>

                <div className='uk-width-1-4@s'>
                   <p></p>
                </div>

             </div>










          </div>
        </Layout>
  )
}

export default Thematic_Areas